import { render, staticRenderFns } from "./CommonPagePlain.vue?vue&type=template&id=e1c6f9dc"
import script from "./CommonPagePlain.vue?vue&type=script&lang=js"
export * from "./CommonPagePlain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports